/**
 * Casino-supplied navigation targets from the launch payload
 * (`lobby_url` / `deposit_url`), delivered via GET design_system. Memory-only:
 * design_system is refetched on every boot, so there is nothing to persist.
 * Same subscribe/snapshot shape as `shipping/store` so consumers can read it
 * through `useSyncExternalStore`.
 */
export interface OperatorLinks {
  lobbyUrl: string | null;
  depositUrl: string | null;
}

const EMPTY: OperatorLinks = Object.freeze({ lobbyUrl: null, depositUrl: null });

let current: OperatorLinks = EMPTY;
const listeners = new Set<() => void>();

function notify(): void {
  for (const cb of listeners) cb();
}

export function loadOperatorLinks(): OperatorLinks {
  return current;
}

export function saveOperatorLinks(next: OperatorLinks): void {
  if (next.lobbyUrl === current.lobbyUrl && next.depositUrl === current.depositUrl) return;
  current = { lobbyUrl: next.lobbyUrl, depositUrl: next.depositUrl };
  notify();
}

export function clearOperatorLinks(): void {
  saveOperatorLinks(EMPTY);
}

export function subscribe(cb: () => void): () => void {
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
  };
}
